import React from 'react'
import {motion} from 'framer-motion'
import TileDisplay from './TileDisplay'

const WordResult = ({wordData}) => {
  if (!wordData) return null

  // Use the arrays directly (no splitting needed since they're already arrays)
  const graphemes = wordData.graphemes || []
  const phonemes = wordData.phonemes || []

  console.log('WordResult - Graphemes:', graphemes)
  console.log('WordResult - Phonemes:', phonemes)

  return (
    <motion.div
      initial={{opacity: 0, y: 30}}
      animate={{opacity: 1, y: 0}}
      transition={{duration: 0.4}}
      className="w-full max-w-4xl mx-auto space-y-8"
    >
      {/* Word Header */}
      <div className="text-center card-subtle rounded-xl p-6 shadow-sm">
        <h2 className="text-4xl font-bold text-gray-900 mb-2">{wordData.word}</h2>
        <div className="w-24 h-1 bg-primary mx-auto rounded-full"></div>
      </div>

      {/* Graphemes */}
      {graphemes.length > 0 && (
        <div className="card-subtle rounded-xl p-6 shadow-sm">
          <TileDisplay
            title="Graphemes"
            tiles={graphemes}
            bgColor="#b5c9c8"
            textColor="#1f2937"
          />
        </div>
      )}

      {/* Phonemes */}
      {phonemes.length > 0 && (
        <div className="card-subtle rounded-xl p-6 shadow-sm">
          <TileDisplay
            title="Phonemes"
            tiles={phonemes.map(p => `/${p}/`)} // Add slashes to phonemes for display
            bgColor="#ccacb2"
            textColor="#1f2937"
          />
        </div>
      )}

      {/* Show message if no phonemes found */}
      {phonemes.length === 0 && (
        <motion.div
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          className="text-center py-8 card-subtle rounded-xl shadow-sm"
        >
          <p className="text-gray-600">
            Word found but no phoneme data available in the database.
          </p>
        </motion.div>
      )}

      {/* Debug info (remove in production) */}
      {process.env.NODE_ENV === 'development' && (
        <div className="text-xs text-gray-400 text-center space-y-1 card-subtle rounded-lg p-3">
          <div>Graphemes ({graphemes.length}): [{graphemes.join(', ')}]</div>
          <div>Phonemes ({phonemes.length}): [{phonemes.join(', ')}]</div>
        </div>
      )}
    </motion.div>
  )
}

export default WordResult